import axios from "axios";
import baseURL from './url'

const service = axios.create({
  baseURL: baseURL.url,
  timeout: 120000, // 请求的超时时间
})
service.interceptors.request.use((config) => {
  // 在发送请求之前做些什么
  config.headers.ticket = sessionStorage.getItem('ticket') || ''
  config.headers.portalSession = sessionStorage.getItem('portalSession') || ''
  config.headers.serviceUrl = encodeURIComponent(sessionStorage.getItem('serviceUrl')|| '') || ''
  // config.headers.cAppId =  'dengsonglin'
  // config.headers.cAppKey = 'dengsonglin'
  return config;
}, (error) => {
  service.cancle = null
  // 对请求错误做些什么
  return Promise.reject(error);
});
// 添加响应拦截器
service.interceptors.response.use((response) => {
  return response.data
}, (error) => {
  // console.log(error.response, 'error')
  // 对响应错误做点什么
  return Promise.reject(error);
});
export default service